// @ts-nocheck
import {useEffect, useMemo} from "react";
import {useLocation} from "react-router-dom";
import {setCookie} from "@/providers/cookieStorage";
import {useAuthStore} from "@/store/useAuth.store";

const useGetRefParams = () => {
  const location = useLocation();
  const authStatus = useAuthStore(state => state.authStatus);

  const {ref, utmCampaign} = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return {
      ref: searchParams.get("ref"),
      utmCampaign: searchParams.get("utm_campaign"),
    };
  }, [location.search]);

  useEffect(() => {
    if (ref) {
      setCookie("referred", ref);
    }
  }, [ref]);

  useEffect(() => {
    // If user came from utm_campaign and is not authenticated, open signup modal
    if (utmCampaign && authStatus === "unauthenticated") {
      useAuthStore.getState().handleAuthForm("registration");
      useAuthStore.getState().handleShowAuthModal();
    }
  }, [utmCampaign, authStatus]);

  return ref || utmCampaign;
};

export default useGetRefParams;
